import type { SkeletonData } from "@esotericsoftware/spine-core";

export function spineFactionsPrefix(): string {
  const base = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
  return `${base}/spine-factions/`;
}

/** Prefer common loop names, then first exported animation. */
export function pickLoopAnimationName(data: SkeletonData): string {
  const names = data.animations.map((a) => a.name);
  for (const cand of ["idle", "Idle", "animation", "Animation"]) {
    if (names.includes(cand)) return cand;
  }
  return names[0] ?? "animation";
}
